export const deviceCardValues = [
  'last_hour',
  'today',
  'all_times',
  'date_of_last_reset']
